<template>
    <section>
        <Tile title="Playlists" subtitle="Popular collections" url="/playlists" />
        <div class="-mx-1.5">
            <Carousel :settings="settings" :breakpoints="breakpoints">
                <Slide v-for="playlist in playlists" :key="playlist.id">
                    <Link
                        class="group mx-1.5 flex h-24 w-full items-center gap-3 rounded-2xl bg-white/[0.035] p-3 text-left ring-1 ring-inset ring-white/[0.06] transition-colors hover:bg-white/[0.07] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent"
                        :href="'/playlist/' + playlist.id"
                    >
                        <img v-if="playlist.cover" :src="playlist.cover" :alt="playlist.name" loading="lazy"
                            class="h-full aspect-square shrink-0 rounded-xl object-cover" />
                        <span v-else class="flex h-full aspect-square shrink-0 items-center justify-center rounded-xl bg-nomad-accent/10 text-2xl text-nomad-accent">
                            <span class="icon-music"></span>
                        </span>
                        <span class="min-w-0">
                            <span class="block truncate font-semibold text-white transition-colors group-hover:text-nomad-accent">{{ playlist.name }}</span>
                            <span class="block text-sm text-nomad-400">{{ playlist.songs_count }} songs</span>
                        </span>
                    </Link>
                </Slide>
            </Carousel>
        </div>
    </section>
</template>
<script setup>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { Link } from "@inertiajs/vue3";
import Tile from "@/components/Tile.vue";

const settings = {
    itemsToShow: 1.2,
    snapAlign: "center",
};
const breakpoints = {
    700: {
        itemsToShow: 2.2,
        snapAlign: "center",
    },
    1024: {
        itemsToShow: 4.2,
        snapAlign: "start",
    },
};
defineProps({ playlists: Array });
</script>
